import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { TextInput } from "@mantine/core"
import type { IProps } from "./interfaces"

export function SearchInput({ value, onChange, placeholder }: IProps): React.JSX.Element {
  const { i18n } = useLingui()
  return (
    <TextInput
      placeholder={placeholder ?? i18n._(msg`Search...`)}
      aria-label={placeholder ?? i18n._(msg`Search`)}
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      size="sm"
      w={200}
    />
  )
}
